import React from "react";
// import "./StatsBar.css";
import {
  FaTrophy,
  FaUsers,
  FaBoxOpen,
  FaMapMarkedAlt,
} from "react-icons/fa";

const StatsBar = () => {
  return (
    <section className="statsBar">
      <div className="statsContainer">

        <div className="statItem">
          <div className="statIcon">
            <FaTrophy />
          </div>

          <div className="statText">
            <h3>20+</h3>
            <p>Years of Experience</p>
          </div>
        </div>

        <div className="divider"></div>

        <div className="statItem">
          <div className="statIcon">
            <FaUsers />
          </div>

          <div className="statText">
            <h3>500+</h3>
            <p>Successful Events</p>
          </div>
        </div>

        <div className="divider"></div>

        <div className="statItem">
          <div className="statIcon">
            <FaBoxOpen />
          </div>

          <div className="statText">
            <h3>1000+</h3>
            <p>Products Delivered</p>
          </div>
        </div>

        <div className="divider"></div>

        <div className="statItem">
          <div className="statIcon">
            <FaMapMarkedAlt />
          </div>

          <div className="statText">
            <h3>Nationwide</h3>
            <p>New Zealand Coverage</p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default StatsBar;